import googleLogo from '@/common/google-logo.svg'
import microsoftLogo from '@/common/microsoft-logo.svg'

export type EmailProvider = 'google' | 'microsoft'

interface ProviderDisplay {
  name: string
  serviceName: string
  logo: string
  accentColor: string
}

const PROVIDERS: Record<EmailProvider, ProviderDisplay> = {
  google: {
    name: 'Google',
    serviceName: 'Gmail',
    logo: googleLogo,
    accentColor: '#34A853',
  },
  microsoft: {
    name: 'Microsoft',
    serviceName: 'Outlook',
    logo: microsoftLogo,
    accentColor: '#0078D4',
  },
}

export const isV2 = true

export function getProviderDisplay(provider: string | undefined): ProviderDisplay {
  if (provider && provider in PROVIDERS) return PROVIDERS[provider as EmailProvider]
  return PROVIDERS.google
}

export function getEmailModuleName(providers?: string[]): string {
  if (!providers?.length) return 'Email'
  const unique = [...new Set(providers)]
  if (unique.length === 1) return getProviderDisplay(unique[0]).serviceName
  return 'Email'
}

export function getConnectLabel(provider?: string): string {
  if (!provider) return 'Connect Email'
  return `Connect ${getProviderDisplay(provider).name}`
}

export const EMAIL_PROVIDERS = Object.keys(PROVIDERS) as EmailProvider[]

export { googleLogo, microsoftLogo }
